import LTR from "@brand-icons/ploom/chevron-bold-backward/chevron-bold-backward-ltr.svg";
import RTL from "@brand-icons/ploom/chevron-bold-backward/chevron-bold-backward-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ChevronBoldBackwardIcon = iconFactory("ChevronBoldBackwardIcon", LTR, RTL);
